<template>
  <div class="rs-tg3d" id="goz_esnetme"></div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
export default {
  name: "GozEsnekligi",
  data() {
    return {};
  },
  mounted() {
    var el = document.querySelector(".rs-tg3d");
    var tg3d = new Tangram3D(el);
    window.tg3d = tg3d;
  },
  beforeDestroy() {
    $(".trophy-level-title").remove();
    window.tg3d.assetManager.firework.context.close();
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
#goz_esnetme {
  width: 100%;
  height: calc(100vh - 113px) !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.trophy-level-title {
  top: 80px !important;
  font-family: inherit !important;
  color: #1c449c !important;
  letter-spacing: 0px;
  font-weight: bold;
}

.rs-hscreen-header .app-title {
  font-family: inherit !important;
  font-size: 40px;
  color: #1c449c !important;
  margin-bottom: 70px !important;
  letter-spacing: 0px;
}

.rs-hscreenmenu .menu-item {
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  padding: 12px;
  margin: 22px;
  border: 2px solid #fff;
  border-radius: 8px;
  transition: all 0.2s ease-out;
  background: #1c449c;
}

.rs-hscreen-header .app-logo {
  height: 150px !important;
  width: auto !important;
}

.rs-hscreenmenu {
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translate(-50%, -50%);
  top: unset !important;
}

.rs-hscreen-header {
  top: 30% !important;
}

.app-info {
  display: none !important;
}

.rs-tg3d-mainbutton-extra {
  background: #1c449c !important;
}

.rs-tg3d-mainbutton {
  display: block;
  width: 36px;
  height: 36px;
  line-height: 33px;
  text-align: center;
  border-radius: 50%;
  font-size: 20px;
  border: 2px solid #fff;
  background: #e1ceb7;
  color: #ffffff;
  transition: all 0.1s ease-out;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Tangram.vue